import React, { useEffect } from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import makeUpdateSourceFile from 'fetches/makeUpdateSourceFile';

import Typography from '@material-ui/core/Typography';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

interface Props {
  sourceFileId: string | null;
  sourceId: string;
}

function CsvUploadSuccess({ sourceFileId, sourceId }: Props) {
  const classes = useStyles();
  const analytics = useAnalytics();
  const dispatch = useDispatch();

  const updateSourceFile = makeUpdateSourceFile(sourceId);

  useEffect(() => {
    analytics.track('Data Sync - Success State Dialog Appear', {
      category: 'AD - Directories',
    });

    setTimeout(() => {
      sourceFileId && dispatch(updateSourceFile({ isActive: true, sourceFileId }));
    }, 500);
  }, []);

  return (
    <div className={classes.root}>
      <CheckCircleRoundedIcon className={classes.icon} titleAccess="Success Icon" />
      <Typography variant="h6">Upload Successful!</Typography>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 'auto',
  },
  icon: {
    color: theme.palette.success.main,
    minHeight: 141,
    minWidth: 141,
    marginBottom: theme.spacing(3),
  },
}));

export default CsvUploadSuccess;
